import axios from 'axios';
import interceptorRequestAxios from '../interceptors/request-axios';
import { interceptorResponseAxios, interceptorResponseErrorAxios } from '../interceptors/response-axios';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const api = axios.create({
    baseURL: retornoHashValor(process.env.REACT_APP_1),
    headers: { 'Content-Type': 'application/json',
        'x-auth-token': localStorage.getItem('token') }
});

if (process.env.REACT_APP_ENV === 'prod') {
    api.interceptors.request.use(interceptorRequestAxios);
    api.interceptors.response.use(interceptorResponseAxios, interceptorResponseErrorAxios);
}

export default api;
